'use strict';

var boolean = function boolean(value) {
  if (typeof value === 'string') {
    return (/^(true|t|yes|y|1)$/i.test(value.trim())
    );
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  return false;
};

module.exports = boolean;


//////////////////
// WEBPACK FOOTER
// ./~/boolean/dist/boolean.js
// module id = 903
// module chunks = 210386719708000